/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_Merge_TitleInputs */

const en_translation_merge_title = /** @type {(inputs: Translation_Merge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Translation Merge`)
};

const fr_translation_merge_title = /** @type {(inputs: Translation_Merge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusion de traduction`)
};

const de_translation_merge_title = /** @type {(inputs: Translation_Merge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersetzungszusammenführung`)
};

const it_translation_merge_title = /** @type {(inputs: Translation_Merge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unione di traduzioni`)
};

const ru_translation_merge_title = /** @type {(inputs: Translation_Merge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Слияние переводов`)
};

const es_translation_merge_title = /** @type {(inputs: Translation_Merge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusión de traducciones`)
};

const zh_cn2_translation_merge_title = /** @type {(inputs: Translation_Merge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翻译合并`)
};

const ja_translation_merge_title = /** @type {(inputs: Translation_Merge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翻訳マージ`)
};

const hi_translation_merge_title = /** @type {(inputs: Translation_Merge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुवाद विलय`)
};

const pt_pt2_translation_merge_title = /** @type {(inputs: Translation_Merge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusão de traduções`)
};

/**
* | output |
* | --- |
* | "Translation Merge" |
*
* @param {Translation_Merge_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_merge_title = /** @type {((inputs?: Translation_Merge_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_Merge_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_translation_merge_title(inputs)
	if (locale === "de") return de_translation_merge_title(inputs)
	if (locale === "it") return it_translation_merge_title(inputs)
	if (locale === "ru") return ru_translation_merge_title(inputs)
	if (locale === "es") return es_translation_merge_title(inputs)
	if (locale === "zh-CN") return zh_cn2_translation_merge_title(inputs)
	if (locale === "ja") return ja_translation_merge_title(inputs)
	if (locale === "hi") return hi_translation_merge_title(inputs)
	if (locale === "pt-PT") return pt_pt2_translation_merge_title(inputs)
	return en_translation_merge_title(inputs)
});